export const CLASS_ACTIVITY_ITEM = 'card-activity-item';
export const CLASS_ACTIVITY_ITEM_TEMP = CLASS_ACTIVITY_ITEM + '--temp';

export const SMALL_ACTIVITY_MIN_ASIDE_WIDTH = 660;
